import React, { FC } from 'react';
import { createStyles, makeStyles } from '@material-ui/styles';
import { Container, Theme, Typography } from '@material-ui/core';

interface HistoryTextSectionProps {
  text: string;
}
interface HistoryTextArrayProps {
  textList: Array<HistoryTextSectionProps>;
}

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    root: {
      marginTop: theme.spacing(9),
    },
    text: { marginTop: theme.spacing(3) },
  });
});

const HistoryTextSection: FC<HistoryTextArrayProps> = ({ textList }) => {
  const classes = useStyles();
  return (
    <Container fixed className={classes.root}>
      {textList.map((item, index) => (
        <Typography className={classes.text} key={index} data-aos="fade-up">
          {item.text}
        </Typography>
      ))}
    </Container>
  );
};

export default HistoryTextSection;
